import { useMeQuery } from '@/graphql/generated';
import { freshToken } from '@/helpers/freshToken.helper';

export function useMe() {
  const { data } = useMeQuery(undefined, { cacheTime: Infinity, enabled: freshToken.hasRefreshToken() });

  return data?.me;
}
